
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBackBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 375,
  height: 41,
  viewBox: "0 0 375 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M308.656 20.12h-5.712v-1.392h7.104V27h-1.392v-6.88Zm-5.36 1.984h1.424V27h-1.424v-4.896Zm12.963-.368c0-.619-.117-1.04-.352-1.264-.224-.235-.619-.352-1.184-.352h-3.056v-1.392h3.056c.725 0 1.296.09 1.712.272.427.181.736.49.928.928.192.437.288 1.04.288 1.808V27h-1.392v-5.264Zm4.54 3.024c0-.97-.043-1.765-.128-2.384s-.245-1.13-.48-1.536a2.586 2.586 0 0 0-1.024-.976l.128-1.136h3.584v1.392l-1.952-.032c.501.341.832.885.992 1.632.171.747.256 1.733.256 2.96V27h-1.392l.016-2.24Zm4.072-6.032h4.256c.682 0 1.226.09 1.632.272.405.181.704.485.896.912.192.416.288.992.288 1.728V27h-1.376v-5.36c0-.576-.112-.97-.336-1.184-.224-.224-.592-.336-1.104-.336h-2.864V27h-1.392v-8.272ZM344.26 18.044a.875.875 0 0 1 .067-1.304 1.064 1.064 0 0 1 1.323-.019l.09.081 5 5.077a.869.869 0 0 1 .079 1.15l-.079.092-5 5.077a1.06 1.06 0 0 1-1.413.062.873.873 0 0 1-.146-1.213l.079-.091 4.389-4.455-4.389-4.457Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"375\" height=\"41\" viewBox=\"0 0 375 41\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M308.656 20.12H302.944V18.728H310.048V27H308.656V20.12ZM303.296 22.104H304.72V27H303.296V22.104ZM316.259 21.736C316.259 21.1173 316.142 20.696 315.907 20.472C315.683 20.2373 315.288 20.12 314.723 20.12H311.667V18.728H314.723C315.448 18.728 316.019 18.8187 316.435 19C316.862 19.1813 317.171 19.4907 317.363 19.928C317.555 20.3653 317.651 20.968 317.651 21.736V27H316.259V21.736ZM320.799 24.76C320.799 23.7893 320.756 22.9947 320.671 22.376C320.586 21.7573 320.426 21.2453 320.191 20.84C319.956 20.4347 319.615 20.1093 319.167 19.864L319.295 18.728H322.879V20.12L320.927 20.088C321.428 20.4293 321.759 20.9733 321.919 21.72C322.09 22.4667 322.175 23.4533 322.175 24.68V27H320.783L320.799 24.76ZM324.871 18.728H329.127C329.809 18.728 330.353 18.8187 330.759 19C331.164 19.1813 331.463 19.4853 331.655 19.912C331.847 20.328 331.943 20.904 331.943 21.64V27H330.567V21.64C330.567 21.064 330.455 20.6693 330.231 20.456C330.007 20.232 329.639 20.12 329.127 20.12H326.263V27H324.871V18.728Z\" fill=\"black\"/>\r\n<path d=\"M344.26 18.044C343.889 17.6668 343.919 17.083 344.327 16.7401C344.705 16.4235 345.272 16.4228 345.65 16.7213L345.74 16.8022L350.74 21.8791C351.058 22.2018 351.084 22.6805 350.819 23.0293L350.74 23.1209L345.74 28.1978C345.368 28.5751 344.736 28.6029 344.327 28.2599C343.95 27.9434 343.895 27.4216 344.181 27.0465L344.26 26.956L348.649 22.5009L344.26 18.044Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/Back-black.dbbac95e7fe8236089db9a9084c264b9.svg"),
        {
          React: SvgBackBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      